import { render, staticRenderFns } from "./Part2.vue?vue&type=template&id=1c4937f0&scoped=true&"
import script from "./Part2.vue?vue&type=script&lang=js&"
export * from "./Part2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4937f0",
  null
  
)

export default component.exports